import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async () => {
    if (!email || !password) {
      alert("Enter email & password");
      return;
    }

    try {
      setLoading(true);

      const res = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      // 🔥 refresh token (VERY IMPORTANT)
      await res.user.getIdToken(true);

      const token = await res.user.getIdTokenResult();

      if (token.claims.admin) {
        window.location.href = "/";
      } else {
        alert("❌ Not Admin");
        await auth.signOut();
      }

    } catch (e) {
      console.error(e);
      alert("Login Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={box}>
        <h2>🔐 Admin Login</h2>

        <input
          type="email"
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={login} disabled={loading}>
          {loading ? "Logging..." : "Login"}
        </button>
      </div>
    </div>
  );
}

/* 🎨 UI */
const container = {
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#0f172a",
};

const box = {
  background: "#1E2235",
  padding: 30,
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  gap: 12,
  width: 300,
};

export default AdminLogin;